<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>HELP.TITLE</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ion-list>
    <ion-item button (click)="openLink('FAQ')"><div translate>HELP.FAQ</div></ion-item>
    <ion-item button (click)="openLink('PRIVACY')"><div translate>HELP.PRIVACY</div></ion-item>
    <ion-item button (click)="openLink('CONDITIONS')"><div translate>HELP.CONDITIONS</div></ion-item>
    <ion-item button (click)="openLink('CONTACT')"><div translate>HELP.CONTACT</div></ion-item>
    <ion-item button (click)="openLink('ABOUT')"><div translate>HELP.ABOUT</div></ion-item>
  </ion-list>

</ion-content>
